import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import ShortcutsSelect from './ShortcutsSelect';

function CustomActionbar(props) {
  const { shortcutItems, selectedDefaultId, handleAccept, handleClose, handleDefaultSelect, isValidRange } = props;

  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderColor: 'border.light',
        padding: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gridColumn: '1/3',
        gridRow: '3',
      }}
    >
      {shortcutItems && selectedDefaultId ? (
        <Stack direction='row' gap={1} alignItems='center'>
          <Typography variant='paragraphRegular' color='text.secondary'>
            Default to show
          </Typography>
          <ShortcutsSelect
            shortcutItems={shortcutItems}
            selectedId={selectedDefaultId}
            handleSelect={handleDefaultSelect}
          />
        </Stack>
      ) : (
        <Box></Box>
      )}
      <Stack direction='row' gap={1} justifyContent='flex-end'>
        <Button variant='outlined' id='cancel-date-range' onClick={handleClose}>
          Cancel
        </Button>
        <Button variant='contained' id='apply-date-range' onClick={handleAccept} disabled={!isValidRange}>
          Apply Dates
        </Button>
      </Stack>
    </Box>
  );
}

CustomActionbar.propTypes = {
  shortcutItems: PropTypes.array,
  selectedDefaultId: PropTypes.string,
  handleAccept: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleDefaultSelect: PropTypes.func.isRequired,
  isValidRange: PropTypes.bool.isRequired,
};

export default CustomActionbar;
